// @core/api/endpoints/context/update_user_context_preferences.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateUserContextPreferencesRequest,
  UpdateUserContextPreferencesResponse,
} from '../../../types/context';

const BASE_PATH = '/context';

/**
 * Update user context preferences
 * Updates the current user's Context Panel preferences. Supports partial updates — only provided fields are modified.
 */
export async function UpdateUserContextPreferences(
  data: UpdateUserContextPreferencesRequest,
  options?: RequestOptions
): Promise<UpdateUserContextPreferencesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/context/config/user`;
  const requestOptions = options;
  return client.patch<UpdateUserContextPreferencesResponse>(requestPath, data, requestOptions);
}
